import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface UserProfile {
  id: string
  name: string | null
  firstName: string | null
  lastName: string | null
  email: string
  loginid: string | null
  extension: string | null
  location: string | null
  branch: string | null
  department: string | null
  avatarUrl: string | null
  employeeId: string | null
  sex: string | null
  mobileNumber: string | null
  dateOfBirth: string | null
  address: string | null
  country: string | null
  timezone: string | null
  dateOfJoining: string | null
  userType: string | null
  status: string | null
  callerIdName: string | null
  callerIdNumber: string | null
  allowOutboundCalling: boolean | null
  allowExtensionCalling: boolean | null
  enableRecording: boolean | null
  enableVoicemail: boolean | null
  maxConcurrentCalls: number | null
  createdAt: string | null
}

export function useUserProfile(userId: string | undefined) {
  const [profile, setProfile] = useState<UserProfile | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async () => {
    if (!userId) {
      setLoading(false)
      return
    }
    setLoading(true)
    setError(null)
    try {
      const res = await api.get<{ profile: UserProfile }>(`/agent/company-directory/${userId}`)
      setProfile(res.profile)
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to fetch profile')
    } finally {
      setLoading(false)
    }
  }, [userId])

  useEffect(() => {
    void refetch()
  }, [refetch])

  return { profile, loading, error, refetch }
}
